"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "NuiPageContainer", {
  enumerable: true,
  get: function get() {
    return _NuiPageContainer.default;
  }
});
var _NuiPageContainer = _interopRequireDefault(require("./NuiPageContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }